import{createContext}from'react';export const AddressInputContext=createContext({});